<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="overlay"></div>

<div class="error-content flexbox">
  <span class="error-icon"></span>

  <div class="flex-1">
    <h1 class="error-code">500</h1>

    <h3 class="font-strong text-uppercase" i18n="@@serverError">Internal Server Error</h3>

    <p class="mb-4" i18n="@@serverErrorStense">There is a problem with server.</p>

    <app-display-go-home></app-display-go-home>
  </div>
</div>
